<script lang="ts">
import { defineComponent } from 'vue';
import { capitalizeWord, generateId } from '@/utils/utils';
import { NULL_PLACEHOLDER } from '@/utils/constants.utils';

enum ComponentEvent {
	CHECK = 'check',
}

/**
 *
 * @version 1.0.0
 * @since
 */
export default defineComponent({
	name: 'CButtonRadio',
	props: {
		name: {
			required: true,
			type: String,
		},
		value: {
			required: true,
			type: String,
		},
		checked: {
			required: false,
			type: Boolean,
			default: false,
		},
		label: {
			required: false,
			type: String,
			default: '',
		},
	},
	setup() {
		return {
			id: String(generateId()),
			capitalizeWord,
			NULL_PLACEHOLDER,
		};
	},
	methods: {
		onChange(event: Event) {
			this.$emit(ComponentEvent.CHECK, event);
		},
	},
});
</script>

<template>
	<label
		class="c-button-radio"
		:for="id"
	>
		<input
			:id="id"
			ref="input"
			type="radio"
			:name="name"
			:value="value"
			:checked="checked"
			@change="onChange"
		>
		<div>
			<span class="c-button-radio__checkmark flex-center">
				<span class="c-button-radio__checkmark-dot" />
			</span>
		</div>
		<label
			class="c-button-radio__label ml-8"
			:for="id"
		>
			<slot>
				{{ label || capitalizeWord(value, NULL_PLACEHOLDER) }}
			</slot>
		</label>
	</label>
</template>

<style scoped lang="scss">
input[type='radio'] {
	display: none;
}

.c-button-radio {
	display: flex;
	justify-content: flex-start;
	align-items: center;
}

.c-button-radio__label {
  @include tools.font-size(14px, 24px);
  color: #212529;
}

.c-button-radio__checkmark {
	@include tools.size(16px, 16px);

	border: 1px solid tokens.$color-gray-e1;
	border-radius: 50%;
  background-color: white;
}

input[type='radio']:checked {
  ~ div {
    .c-button-radio__checkmark {
      background-color: #0D6EFD;
      border-color: #0D6EFD;
    }

    .c-button-radio__checkmark-dot {
      @include tools.size(8px, 8px);
      background-color: white;
      border-radius: 50%;
    }
  }
}

.c-button-radio:hover .c-button-radio__checkmark {
	border: 1px solid #0D6EFD;
}
</style>
